import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy di IlTuoAmaro.it</h1>
          
          <div className="prose prose-gray max-w-none">
            <div className="border-b border-gray-200 pb-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Titolare del Trattamento dei Dati
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="font-semibold text-gray-900">Lacinio S.R.L.</p>
                <p className="text-gray-700">Via G. Mercalli, 16 – Z.I.</p>
                <p className="text-gray-700">88900 Crotone (KR) – ITALIA</p>
                <p className="text-gray-700">P.IVA: 03714460791 – REA KR-184420</p>
                <p className="text-gray-700">E-mail del Titolare: info@iltuoamaro.it</p>
                <p className="text-gray-700">Telefono: +39 0962 937186</p>
              </div>
            </div>

            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Tipologie di Dati raccolti</h3>
                <p className="text-gray-700 mb-4">
                  Fra i Dati Personali raccolti da questo Sito Web, in modo autonomo o tramite terze parti, possono esserci: 
                  e-mail; Cookie; Dati di utilizzo; nome; cognome; stato; città; numero di telefono; nazione; 
                  Dati comunicati durante l'utilizzo del servizio.
                </p>
                <p className="text-gray-700 mb-4">
                  I dettagli completi su ciascuna tipologia di Dati sono forniti nelle sezioni dedicate di questa informativa 
                  o mediante specifici testi informativi mostrati prima della raccolta.
                </p>
                <p className="text-gray-700 mb-4">
                  I Dati Personali possono essere liberamente forniti dall'Utente oppure, nel caso di Dati di Utilizzo, 
                  raccolti automaticamente durante l'uso del Sito.
                </p>
                <p className="text-gray-700 mb-4">
                  Se non diversamente specificato, tutti i Dati richiesti sono obbligatori. Il loro mancato conferimento 
                  può rendere impossibile l'erogazione del Servizio. Nei casi in cui alcuni Dati siano indicati come facoltativi, 
                  gli Utenti sono liberi di non comunicarli senza conseguenze sulla disponibilità del Servizio.
                </p>
                <p className="text-gray-700 mb-4">
                  Gli Utenti che hanno dubbi su quali Dati siano obbligatori sono incoraggiati a contattare il Titolare.
                </p>
                <p className="text-gray-700 mb-4">
                  L'eventuale uso di Cookie o altri strumenti di tracciamento da parte di questo Sito o dei servizi di terze parti 
                  utilizzati ha la finalità di erogare il Servizio richiesto dall'Utente e le ulteriori finalità descritte in questa 
                  informativa e nella Cookie Policy (se disponibile).
                </p>
                <p className="text-gray-700">
                  L'Utente è responsabile dei Dati Personali di terzi ottenuti, pubblicati o condivisi mediante questo Sito Web 
                  e garantisce di avere il diritto di comunicarli o diffonderli, manlevando il Titolare da ogni responsabilità verso terzi.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Modalità e luogo del trattamento dei Dati raccolti</h3>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Modalità di trattamento</h4>
                    <p className="text-gray-700 mb-3">
                      Il Titolare adotta misure di sicurezza idonee a impedire accesso, divulgazione, modifica o distruzione 
                      non autorizzate dei Dati Personali.
                    </p>
                    <p className="text-gray-700 mb-3">
                      Il trattamento avviene con strumenti informatici e/o telematici, secondo modalità organizzative e logiche 
                      strettamente correlate alle finalità indicate. Oltre al Titolare, in alcuni casi, possono avere accesso ai Dati 
                      altri soggetti coinvolti nell'organizzazione del Sito (es. amministrazione, commerciale/marketing, legali, 
                      amministratori di sistema) o soggetti esterni (fornitori di servizi tecnici, corrieri, hosting provider, 
                      società informatiche, agenzie di comunicazione), nominati – ove necessario – Responsabili del Trattamento.
                    </p>
                    <p className="text-gray-700">
                      L'elenco aggiornato dei Responsabili è disponibile su richiesta.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Base giuridica del trattamento</h4>
                    <p className="text-gray-700 mb-3">
                      Il Titolare tratta Dati Personali dell'Utente in presenza di una delle seguenti condizioni:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-3">
                      <li>l'Utente ha prestato consenso per una o più specifiche finalità;</li>
                      <li>il trattamento è necessario all'esecuzione di un contratto con l'Utente e/o a misure precontrattuali;</li>
                      <li>il trattamento è necessario per adempiere un obbligo legale al quale è soggetto il Titolare;</li>
                      <li>il trattamento è necessario per l'esecuzione di un compito di interesse pubblico o per l'esercizio di pubblici poteri;</li>
                      <li>il trattamento è necessario per il perseguimento del legittimo interesse del Titolare o di terzi.</li>
                    </ul>
                    <p className="text-gray-700">
                      È sempre possibile chiedere al Titolare di chiarire la base giuridica concreta di ciascun trattamento.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Luogo</h4>
                    <p className="text-gray-700 mb-3">
                      I Dati sono trattati presso le sedi operative del Titolare e in ogni altro luogo in cui le parti coinvolte 
                      nel trattamento siano localizzate. I Dati Personali dell'Utente potrebbero essere trasferiti in paesi diversi 
                      da quello in cui l'Utente si trova.
                    </p>
                    <p className="text-gray-700">
                      L'Utente ha diritto a ottenere informazioni sulla base giuridica del trasferimento di Dati al di fuori 
                      dell'UE/SEE o verso organizzazioni internazionali, nonché sulle misure di sicurezza adottate dal Titolare per proteggerli.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Periodo di conservazione</h4>
                    <p className="text-gray-700 mb-3">
                      I Dati sono trattati e conservati per il tempo richiesto dalle finalità per cui sono stati raccolti. In particolare:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-3">
                      <li>i Dati raccolti per finalità contrattuali saranno conservati fino al completamento del contratto e secondo i termini di legge (es. fiscale/contabile);</li>
                      <li>i Dati raccolti per legittimo interesse saranno conservati fino al soddisfacimento di tale interesse;</li>
                      <li>quando il trattamento si basa sul consenso, i Dati saranno conservati fino a revoca del consenso;</li>
                      <li>il Titolare può conservare i Dati più a lungo per obbligo di legge o ordine dell'autorità.</li>
                    </ul>
                    <p className="text-gray-700">
                      Al termine del periodo di conservazione, i Dati saranno cancellati o anonimizzati.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Finalità del Trattamento dei Dati raccolti</h3>
                <p className="text-gray-700 mb-3">I Dati dell'Utente sono raccolti per consentire al Titolare di:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                  <li>erogare il Servizio,</li>
                  <li>adempiere a obblighi di legge,</li>
                  <li>rispondere a richieste o azioni esecutive,</li>
                  <li>tutelare diritti e interessi del Titolare o di Utenti/terzi,</li>
                  <li>individuare attività dolose o fraudolente,</li>
                  <li>svolgere le seguenti attività: gestione database Utenti; statistica; contattare l'Utente; accesso ad account su servizi terzi; remarketing e behavioral targeting; registrazione e autenticazione; gestione tag; gestione richieste di supporto; gestione pagamenti; interazione con social network e piattaforme esterne; live chat; visualizzazione di contenuti da piattaforme esterne.</li>
                </ul>
                <p className="text-gray-700">
                  Per i dettagli, vedere la sezione "Dettagli sul trattamento dei Dati Personali".
                </p>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Permessi Facebook (Meta) richiesti da questo Sito Web</h3>
                <p className="text-gray-700 mb-4">
                  Questo Sito può richiedere alcuni permessi Facebook (Meta) per eseguire azioni con l'account dell'Utente 
                  e raccogliere informazioni, inclusi Dati Personali. Per informazioni aggiornate sui permessi, consultare 
                  la documentazione ufficiale di Meta/Facebook e la relativa privacy policy.
                </p>
                <div>
                  <p className="font-semibold text-gray-700 mb-2">Permessi richiesti (esempi):</p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Informazioni di base (id, nome, immagine, lingua, ecc.)</li>
                    <li>Email (accesso all'indirizzo e-mail primario)</li>
                    <li>Email di contatto</li>
                  </ul>
                </div>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Dettagli sul trattamento dei Dati Personali</h3>
                
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Accesso agli account su servizi terzi</h4>
                    <p className="text-gray-700">
                      Servizi che permettono al Sito di prelevare Dati dagli account dell'Utente su servizi terzi ed eseguire azioni. 
                      Attivi solo previa autorizzazione esplicita dell'Utente.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Contattare l'Utente</h4>
                    <div className="space-y-3">
                      <div>
                        <p className="font-medium text-gray-700">• Mailing list / newsletter (questo Sito Web)</p>
                        <p className="text-gray-700 text-sm">
                          Con la registrazione alla newsletter, l'indirizzo e-mail dell'Utente viene inserito in una lista per l'invio 
                          di comunicazioni informative e promozionali.
                        </p>
                        <p className="text-gray-700 text-sm">Dati trattati: nome; cognome; e-mail.</p>
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">• Modulo di contatto (questo Sito Web)</p>
                        <p className="text-gray-700 text-sm">
                          I Dati inviati tramite form sono utilizzati per rispondere a richieste di informazioni, preventivi, 
                          o altre richieste.
                        </p>
                        <p className="text-gray-700 text-sm">Dati trattati: nome; cognome; e-mail; eventuali altri Dati forniti nel messaggio.</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Gestione dei database di Utenti</h4>
                    <p className="text-gray-700">
                      Servizi che permettono di costruire profili utente e tracciare attività a fini statistici e di personalizzazione, 
                      anche incrociando Dati con informazioni pubbliche (es. social). Possono consentire l'invio programmato di messaggi 
                      (es. e-mail automatiche).
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Gestione dei pagamenti</h4>
                    <p className="text-gray-700 mb-3">
                      Salvo diversa indicazione, i pagamenti sono gestiti da fornitori esterni; l'Utente fornisce i Dati di pagamento 
                      direttamente a tali fornitori. Il Sito riceve esclusivamente conferma dell'avvenuta transazione.
                    </p>
                    <ul className="list-disc pl-6 space-y-1 text-gray-700">
                      <li>PayPal (PayPal Inc.) – vedi privacy policy del fornitore.</li>
                      <li>Carte di credito/debito tramite gateway certificati (es. Stripe o equivalenti): i dati sono trattati dai provider di pagamento.</li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Gestione dei tag</h4>
                    <p className="font-medium text-gray-700">• Google Tag Manager (Google Ireland Limited)</p>
                    <p className="text-gray-700 text-sm">Dati trattati: Cookie; Dati di utilizzo.</p>
                    <p className="text-gray-700 text-sm">Luogo del trattamento: Irlanda.</p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Gestione richieste di supporto</h4>
                    <p className="text-gray-700">
                      Gestione e tracciamento delle richieste di assistenza pervenute via e-mail o form. 
                      I Dati trattati dipendono dal contenuto delle richieste.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Interazione con social network e piattaforme esterne</h4>
                    <p className="text-gray-700">
                      Widget e pulsanti social possono raccogliere Dati di traffico anche se non utilizzati attivamente dall'Utente. 
                      Si raccomanda di disconnettersi dai relativi servizi per evitare associazioni al profilo personale.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Remarketing e behavioral targeting</h4>
                    <p className="text-gray-700 mb-3">
                      Servizi che permettono di comunicare e mostrare annunci basati sull'uso passato del Sito. 
                      L'attività è facilitata da Cookie/ID tecnici. Opzioni di opt-out disponibili presso i singoli fornitori 
                      e tramite le impostazioni del dispositivo.
                    </p>
                    <div className="space-y-2 text-sm">
                      <p className="text-gray-700">• Facebook Custom Audience (Meta Platforms, Inc.) - Dati: Cookie; e-mail. – Luogo: USA.</p>
                      <p className="text-gray-700">• Facebook Remarketing (Meta Platforms, Inc.) - Dati: Cookie; Dati di utilizzo. – Luogo: USA.</p>
                      <p className="text-gray-700">• Google Ads Remarketing (Google Ireland Limited) - Dati: Cookie; Dati di utilizzo. – Luogo: Irlanda.</p>
                      <p className="text-gray-700">L'Utente può gestire le preferenze annunci nelle Impostazioni annunci Google.</p>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Statistica</h4>
                    <div className="space-y-3 text-sm">
                      <div>
                        <p className="font-medium text-gray-700">• Google Analytics (Google Ireland Limited)</p>
                        <p className="text-gray-700">
                          Analisi dell'uso del Sito e reportistica. Google può utilizzare i Dati per personalizzare annunci 
                          nel proprio network.
                        </p>
                        <p className="text-gray-700">Dati: Cookie; Dati di utilizzo. – Luogo: Irlanda.</p>
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">• Monitoraggio conversioni Meta/Facebook (pixel)</p>
                        <p className="text-gray-700">
                          Collega i dati delle campagne con le azioni sul Sito (Facebook, Instagram, Audience Network).
                        </p>
                        <p className="text-gray-700">Dati: Cookie; Dati di utilizzo. – Luogo: USA.</p>
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">• Monitoraggio conversioni Google Ads (Google Ireland Limited)</p>
                        <p className="text-gray-700">Collega i dati delle campagne Google Ads con le azioni sul Sito.</p>
                        <p className="text-gray-700">Dati: Cookie; Dati di utilizzo. – Luogo: Irlanda.</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Visualizzazione di contenuti da piattaforme esterne</h4>
                    <p className="font-medium text-gray-700">• Google Fonts (Google Ireland Limited)</p>
                    <p className="text-gray-700 text-sm">Caricamento di famiglie di caratteri dalle pagine del Sito.</p>
                    <p className="text-gray-700 text-sm">
                      Dati: Dati di utilizzo; dati tecnici trasmessi per la resa dei font. – Luogo: Irlanda.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Vendita di beni e servizi online</h4>
                    <p className="text-gray-700">
                      I Dati sono utilizzati per erogare servizi/prodotti, gestire pagamenti e consegne. 
                      I Dati di pagamento dipendono dal metodo utilizzato e sono trattati dai relativi fornitori.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Diritti dell'Utente</h3>
                <p className="text-gray-700 mb-3">L'Utente può esercitare, nei limiti di legge, i seguenti diritti:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                  <li>revoca del consenso in qualsiasi momento;</li>
                  <li>opposizione al trattamento (anche per marketing diretto, senza motivazione);</li>
                  <li>accesso ai propri Dati e ottenimento di copia;</li>
                  <li>rettifica/aggiornamento;</li>
                  <li>limitazione del trattamento;</li>
                  <li>cancellazione dei Dati ("diritto all'oblio"), quando ricorrono i presupposti;</li>
                  <li>portabilità dei Dati (in formato strutturato, di uso comune e leggibile da dispositivo);</li>
                  <li>reclamo all'Autorità Garante per la Protezione dei Dati Personali (Italia) o azione in sede giudiziale.</li>
                </ul>

                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Dettagli sul diritto di opposizione</h4>
                    <p className="text-gray-700 mb-2">
                      Quando i Dati sono trattati per interesse pubblico, esercizio di pubblici poteri o legittimo interesse 
                      del Titolare, l'Utente può opporsi per motivi connessi alla propria situazione particolare.
                    </p>
                    <p className="text-gray-700">
                      Per marketing diretto, l'Utente può opporsi senza fornire motivazioni.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-3">Come esercitare i diritti</h4>
                    <p className="text-gray-700 mb-2">
                      Le richieste vanno indirizzate al Titolare ai contatti indicati all'inizio.
                    </p>
                    <p className="text-gray-700">
                      Le richieste sono gratuite e saranno evase nel più breve tempo possibile, comunque entro 1 mese 
                      (salvo proroghe nei casi previsti dal GDPR).
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Ulteriori informazioni sul trattamento</h3>
                
                <div className="space-y-4">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">Difesa in giudizio</h4>
                    <p className="text-gray-700">
                      I Dati Personali dell'Utente possono essere utilizzati dal Titolare in giudizio o nelle fasi preparatorie 
                      per la difesa da abusi nell'utilizzo del Sito o dei Servizi.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">Informative specifiche</h4>
                    <p className="text-gray-700">
                      Su richiesta, il Sito può fornire informative aggiuntive e contestuali per specifici Servizi o trattamenti.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">Log di sistema e manutenzione</h4>
                    <p className="text-gray-700">
                      Per esigenze di funzionamento e manutenzione, il Sito e gli eventuali servizi terzi possono raccogliere 
                      log di sistema (che possono contenere anche Dati Personali, come l'indirizzo IP).
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">Informazioni non contenute in questa policy</h4>
                    <p className="text-gray-700">
                      Ulteriori informazioni possono essere richieste in qualsiasi momento al Titolare utilizzando i contatti indicati.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">Risposta alle richieste "Do Not Track"</h4>
                    <p className="text-gray-700">
                      Questo Sito non supporta le richieste "Do Not Track". Per sapere se servizi di terze parti le supportano, 
                      consultare le loro privacy policy.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Modifiche a questa Privacy Policy</h3>
                <p className="text-gray-700 mb-4">
                  Il Titolare si riserva il diritto di apportare modifiche alla presente informativa in qualunque momento, 
                  notificandolo su questa pagina e, se possibile, sul Sito e/o tramite comunicazione agli Utenti ai contatti disponibili. 
                  Si prega di consultare periodicamente questa pagina, facendo riferimento alla data di ultima modifica.
                </p>
                <p className="text-gray-700">
                  Qualora le modifiche riguardino trattamenti basati sul consenso, il Titolare raccoglierà nuovamente il consenso, 
                  se necessario.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Definizioni e riferimenti legali</h3>
                
                <div className="bg-gray-50 p-6 rounded-lg">
                  <ul className="space-y-3 text-gray-700 text-sm">
                    <li><strong>Dati Personali (o Dati):</strong> qualsiasi informazione che identifichi o renda identificabile una persona fisica.</li>
                    <li><strong>Dati di Utilizzo:</strong> informazioni raccolte automaticamente (IP, URI, orario richiesta, metodo, dimensione risposta, codice stato, paese, caratteristiche browser/OS, tempi di permanenza, percorso di navigazione, parametri del dispositivo).</li>
                    <li><strong>Utente / Interessato:</strong> la persona fisica cui si riferiscono i Dati.</li>
                    <li><strong>Responsabile del Trattamento:</strong> soggetto che tratta Dati per conto del Titolare.</li>
                    <li><strong>Titolare del Trattamento:</strong> chi determina finalità e mezzi del trattamento.</li>
                    <li><strong>Questo Sito Web (Applicazione):</strong> lo strumento con cui sono raccolti e trattati i Dati.</li>
                    <li><strong>Servizio:</strong> il servizio fornito dal Sito così come definito nei relativi termini.</li>
                    <li><strong>UE/SEE:</strong> Unione Europea/Spazio Economico Europeo.</li>
                    <li><strong>Cookie / Strumenti di Tracciamento:</strong> tecnologie che consentono di tracciare gli Utenti (cookie, identificativi univoci, web beacons, script, e-tag, fingerprinting).</li>
                  </ul>
                </div>
                
                <p className="text-gray-700 mt-4 text-sm">
                  <strong>Riferimenti legali:</strong> Informativa resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR) 
                  e della normativa nazionale applicabile.
                </p>
              </section>
            </div>

            <div className="border-t border-gray-200 pt-8 mt-8">
              <div className="text-center">
                <p className="text-sm text-gray-600 mb-4">Ultima Modifica: 04/10/2025</p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="font-semibold text-gray-900">Titolare: Lacinio S.R.L. – IlTuoAmaro.it</p>
                  <p className="text-gray-700 mt-2">
                    📧 info@iltuoamaro.it | ☎️ +39 0962 937186
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;